import { MESSAGES_EVENTS } from '../../../config/config';
import socket from '../../socket';

export default async ({ commit }) => {
  socket.on(MESSAGES_EVENTS.NEW_CONSUMER_MESSAGE, ({ from }) => {
    commit('consumerOpenMessages', from);
  });
  socket.on(MESSAGES_EVENTS.READ_CONSUMER, ({ consumers }) => {
    commit('consumerOpenMessages', consumers);
  });
};
